export const TipoOperacionAccesoDigital = {
    Asociacion: 1,
    Desvinculacion: 2,
    ReAsociacion: 3,
    RedimePin: 4,
    AceptarTyC: 5,
};
